import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { BookingResponse } from "@/api/types";

export function useBooking(id: string | undefined, options: { refetchOnMount?: "always" } = {}) {
  return useQuery({
    queryKey: ["booking", id],
    queryFn: () => {
      if (!id || id === "." || id === "..") throw new Error("Invalid booking reference.");
      return api.get(`bookings/${encodeURIComponent(id)}`).json<BookingResponse>();
    },
    enabled: !!id,
    staleTime: 30_000,
    refetchOnMount: options.refetchOnMount,
  });
}
